import { api } from "./api";

export const createOrderApi = (params) => {
    return api.post(`/admin/order/create`, JSON.stringify(params));
};

export const editOrderApi = (params) => {
    return api.post(`/admin/order/edit`, JSON.stringify(params));
};

export const listOrderApi = (params) => {
    return api.get(`/admin/order/list`, { params });
};

export const viewOrderApi = (params) => {
    return api.get(`/admin/order/view`, { params });
};

export const approveRejectOrderApi = (params) => {
    return api.post(`/admin/order/approve-reject`, JSON.stringify(params));
};